/**
 * Keeps focusable content out of the tab order while it sits inside an
 * aria-hidden="true" Flickity slide (axe: aria-hidden-focus).
 *
 * A persistent MutationObserver is used (instead of one-off toggling) because
 * third-party widgets (e.g. Klaviyo favorites buttons) inject focusable
 * elements into the slides after Flickity has already set aria-hidden.
 */
(function () {
  var CELL_SELECTOR = '.flickity-slider > [aria-hidden]';
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  var scheduled = false;

  function sync(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    var items = cell.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (hidden) {
        if (el.getAttribute('data-a11y-tabindex') === null) {
          var prev = el.getAttribute('tabindex');
          el.setAttribute('data-a11y-tabindex', prev === null ? '' : prev);
        }
        if (el.getAttribute('tabindex') !== '-1') {
          el.setAttribute('tabindex', '-1');
        }
      } else if (el.getAttribute('data-a11y-tabindex') !== null) {
        var orig = el.getAttribute('data-a11y-tabindex');
        el.removeAttribute('data-a11y-tabindex');
        if (orig === '') {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', orig);
        }
      }
    }
  }

  function syncAll() {
    scheduled = false;
    var cells = document.querySelectorAll(CELL_SELECTOR);
    for (var i = 0; i < cells.length; i++) {
      sync(cells[i]);
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(syncAll);
  }

  function start() {
    syncAll();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
